import ReferralProgramsTemplatesLazy from '@Web/Pages/Web/Home/Components/ReferralProgramsTemplates/Lazy';
import { DEMO_SECTION_DATA, HOME_BLOG, HOME_FAQ } from '@Web/Pages/Web/Home/constants.jsx';
import ReferralPrograms from '@Web/Pages/Auth/Layout/Components/ReferralPrograms';
import GenerateCampaignInput from '@Web/Src/Components/GenerateCampaignInput';
import TutorialsLazy from '@Web/Pages/Web/Home/Components/Tutorials/Lazy';
import SoftwareAbilitiesLazy from '@Web/Src/UI/SoftwareAbilities/Lazy';
import Integrations from '@Web/Pages/Web/Home/Components/Integrations';
import SimpleSwiperLazy from '@Web/Src/Components/SimpleSwiper/Lazy';
import Programs from '@Web/Pages/Web/Home/Components/Programs';
import SectionHeader from '@Web/Src/Components/SectionHeader';
import LinkSection from '@Web/Src/UI/LinkSection';
import BlogSection from '@Web/Src/UI/BlogSection';
import { MEDALS } from '@Web/Src/constants.js';
import FlagsLazy from '@Web/Src/UI/Flags/Lazy';
import DemoInput from '@Web/Src/UI/DemoInput';
import Layout from '@Web/Pages/Web/Layout';
import loadable from '@loadable/component';
import RoiLazy from '@Web/Src/UI/Roi/Lazy';
import { router } from '@inertiajs/react';
import Reviews from '@Web/Src/UI/Reviews';
import Pricing from '@Web/Src/UI/Pricing';
import Faq from '@Web/Src/UI/Faq';

const LazySoftwareAbilities = loadable(() => import('@Web/Src/UI/SoftwareAbilities'), {
    fallback: (
        <SoftwareAbilitiesLazy
            data={DEMO_SECTION_DATA}
            topTitle={true}
            icon={'cube'}
            title={__('How our referral program software works')}
            desc={__(
                'Our plug and play referral program software has everything you need to build, promote, and track your own referral program. Automated rewards, 24/7 support, and more!'
            )}
            type={'light'}
        />
    ),
});

const LazySimpleSwiper = loadable(() => import('@Web/Src/Components/SimpleSwiper'), {
    fallback: <SimpleSwiperLazy />,
});

const LazyTutorials = loadable(() => import('@Web/Pages/Web/Home/Components/Tutorials'), {
    fallback: <TutorialsLazy />,
});

const LazyReferralProgramsTemplates = loadable(
    () => import('@Web/Pages/Web/Home/Components/ReferralProgramsTemplates'),
    {
        fallback: <ReferralProgramsTemplatesLazy />,
    }
);

const LazyFlags = loadable(() => import('@Web/Src/UI/Flags'), {
    fallback: <FlagsLazy />,
});

const LazyRoi = loadable(() => import('@Web/Src/UI/Roi'), {
    fallback: <RoiLazy />,
});

function Home() {
    return (
        <Layout lightTheme={false}>
            <div className='relative'>
                <div
                    className={
                        'bg-builder home-layer bg-defaults medium:!bg-animated-slow bg-animated absolute h-[20%]'
                    }
                ></div>
                <div
                    className={
                        'text-light page-container relative flex flex-col items-center justify-center'
                    }
                >
                    <div className='mt-40'>
                        <ReferralPrograms
                            text={__(
                                'Build a referral program in minutes. Invite your customers to refer. Tap into our network of 100,000+ affiliates. Track referrals. Automate rewards. Grow faster :symbol',
                                {
                                    symbol: '🚀',
                                }
                            )}
                            title={() => (
                                <h1 className='text-light text-[26px] font-bold leading-10 sm:text-[40px]'>
                                    {__('Get More Referrals. :keyWord', {
                                        keyWord: (
                                            <span className='text-blue'>
                                                {__('Automatically')}.
                                            </span>
                                        ),
                                    })}
                                </h1>
                            )}
                        />
                    </div>

                    <div className='mt-14 w-full max-w-[625px]'>
                        <GenerateCampaignInput />
                    </div>
                    <div
                        className={
                            'swiper-mask relative mx-auto mt-24 flex w-full max-w-[695px] items-center overflow-hidden'
                        }
                    >
                        <LazySimpleSwiper items={MEDALS} className={'-mr-3 w-[117px]'} />
                    </div>
                    <LazySoftwareAbilities
                        data={DEMO_SECTION_DATA}
                        topTitle={true}
                        icon={'cube'}
                        title={__('How our referral program software works')}
                        desc={__(
                            'Our plug and play referral program software has everything you need to build, promote, and track your own referral program. Automated rewards, 24/7 support, and more!'
                        )}
                        type={'light'}
                    />
                    <LinkSection
                        handleClick={() => router.visit(route('customer.auth.register'))}
                        link={__('Try our referral marketing software for free')}
                    />
                    <Integrations />
                    <LazyRoi />
                    <LazyTutorials />
                    <LazyFlags />
                    <LazyReferralProgramsTemplates />
                    <DemoInput className={'mt-44'} />
                    <Reviews className={'mt-44'} />

                    <SectionHeader
                        type='dark'
                        className='mx-auto mt-24'
                        icon='credit-card'
                        title={__('Simple pricing that scales as you grow')}
                        desc={__(
                            'No matter whether you want to start small or launch your referral program at scale, there is a pricing plan to suit your needs.'
                        )}
                    />
                    <Pricing />
                    <Programs className={'mt-36'} />
                    <DemoInput className={'mt-40'} />
                    <BlogSection data={HOME_BLOG} />
                    <Faq data={HOME_FAQ} title={__('FAQ')} />
                </div>
            </div>
        </Layout>
    );
}

export default Home;
